import { render, staticRenderFns } from "./SelectionRound.vue?vue&type=template&id=4e3e6b38&lang=pug"
import script from "./SelectionRound.vue?vue&type=script&lang=js"
export * from "./SelectionRound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports